import { Link } from 'react-router-dom'

import economia_2023 from './2023_economia/portada.jpg'

export default function Index() {
  const temas = [
    {
      nombre: 'Economia solidaria 2023',
      imagen: economia_2023,
      texto: 'Charla económia solidaria y tejido social',
      ruta: '/galeria/fortalecimiento-economico/economia-2023',
    }
  ];

  return (
    <div className='container mt-4'>
      <div className='row justify-content-center'>
        <div className='pb-3 text-center'><h4>Galerias - Fortalecimiento económico</h4></div>
        <div className='border-top border-3 mb-3'></div>
        {temas.map((t, i) => (
          <div key={i} className='col-12 col-sm-6 col-md-4 col-lg-2 mb-4'>
            <Link to={t.ruta} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card h-100">
                <img src={t.imagen} className="card-img-top" alt={t.nombre} />
                <div className="card-body">
                  <h6 className="fw-bold">{t.nombre}</h6>
                  <p className="card-text">{t.texto}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
